import {
  Modal,
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Button,
  Skeleton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { GET_MY_CHAT_GROUPS_USERS, INVITEFRIENDSBYEMAIL } from "../../constant/Apipath";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Getrequestcall } from "../../request/Getrequest";
import { Postrequestcall } from "../../request/Postrequest";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { setChatState } from "../../redux/actions/actions";
import NewChatModal from "./NewChatModal";
import { createChatGroupAndNavigate } from "../../common/Helper";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%", // 0px and up (mobile)
    sm: "80%", // 600px and up (tablet)
    md: "600px" // 900px and up (desktop)
  },
  maxHeight: "80vh", // Prevent overflow
  overflowY: "auto", // Scroll inside if content is long
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 3,
  p: 2
};

export default function ShowMembersModal({ open, onClose }) {
  const [chatGroupUsers, setChatGroupUsers] = useState([]);
  const [isConnectLoading, setIsConnectLoading] = useState(null);
  const [isMemberListLoading, setIsMemeberListLoading] = useState(false);
  const [openNewChatModal, setOpenNewChatModal] = useState(false);
  const { loginData } = useSelector((state) => state?.main);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { selectedChat } = useSelector((state) => state?.main);

  const getChatGroupUser = async () => {
    try {
      setIsMemeberListLoading(true);
      const chatGroupId = selectedChat?.chatGroupId;
      const userId = loginData?.userInformation?.UserId;
      const accessToken = loginData?.accessToken;

      if (!chatGroupId || !userId || !accessToken) {
        console.error(
          "getChatGroupUser-> Error Missing Necessary Parameters (chatGroupId, userId, or accessToken)."
        );
        return;
      }

      const res = await Getrequestcall(
        `${GET_MY_CHAT_GROUPS_USERS}/${userId}/${chatGroupId}`,
        accessToken
      );

      if (res?.status === 200 && res?.data?.data) {
        const currentUser = {
          id: 1,
          firstName: loginData?.userInformation?.FirstName,
          lastName: loginData?.userInformation?.LastName,
          userEmail: loginData?.userInformation?.Email,
          tradeName: loginData?.userInformation?.TradeName,
          pictureUrl: loginData?.pictureUrl,
          userId: loginData?.userInformation?.UserId,
          chatGroupId: selectedChat?.chatGroupId,
          contactStatus: "me",
          appRecordName: selectedChat?.appRecordName
        };
        res.data.data.unshift(currentUser);
        setChatGroupUsers(res.data.data);
        setIsMemeberListLoading(false);
      } else {
        console.error(
          "getChatGroupUser-> Error Fetching Chat Group Users Or Invalid Response: ",
          res
        );
        setIsMemeberListLoading(false);
      }
    } catch (error) {
      console.error("getChatGroupUser-> Error While Getting Chat Group User: ", error);
      setIsMemeberListLoading(false);
    }
  };

  const updateMembersData = (userId, status) => {
    setChatGroupUsers((prevUsers) =>
      prevUsers.map((member) =>
        member.userId === userId ? { ...member, contactStatus: status } : member
      )
    );
  };

  const handleConnect = async (member) => {
    try {
      setIsConnectLoading(member.userId);
      const obj = {
        UserId: Number(loginData?.userInformation?.UserId),
        FriendsEmails: member?.userEmail,
        Notification: {
          ActionUrl: `${import.meta.env.REACT_APP_CONTACTPROFILE}${Number(loginData?.userInformation?.UserId)}`,
          title: "Connect Request",
          Body: "has requested to Connect you."
        }
      };

      const response = await Postrequestcall(INVITEFRIENDSBYEMAIL, obj, loginData?.accessToken);

      if (response?.data?.data === "Connect Request Send") {
        updateMembersData(member?.userId, "Request Sent");
      }
      setIsConnectLoading(null);
    } catch (error) {
      setIsConnectLoading(null);
      console.log("handleAddContact-> Error When Inviting Friends By Email: ", error);
    }
  };

  const handleMessageClick = (member) => {
    createChatGroupAndNavigate(member?.userId, loginData, dispatch, navigate, "ShowMembersModal");
    onClose();
  };

  const handleNavigateToProfile = (member) => {
    navigate(`/${member?.userId}`);
  };

  const handleAddMember = () => {
    const chatState = {
      chatGroupId: selectedChat?.chatGroupId,
      from: "showMembersModal"
    };
    dispatch(setChatState(chatState));
    setOpenNewChatModal(true);
    // onClose();
  };

  useEffect(() => {
    if (open) {
      getChatGroupUser();
    }
  }, [open]);

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={style}>
          {/* Header */}
          <Box sx={{ mb: 1,  alignItems: "center",  justifyContent: "space-between",  display: "flex" }}   >
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Members
            </Typography>
            <Box>
              <IconButton onClick={handleAddMember}>
                <AddIcon color="primary" />
              </IconButton>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>

          {/* Member List with Scroll */}
          <List sx={{ height: "auto" }}>
            {isMemberListLoading
              ? // Show Skeletons while loading
                Array.from(new Array(3)).map((_, index) => (
                  <ListItem key={index} sx={{ mb: 1 }}>
                    <ListItemAvatar>
                      <Skeleton variant="circular" width={40} height={40} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={<Skeleton width="80%" />}
                      secondary={<Skeleton width="60%" />}
                    />
                  </ListItem>
                ))
              : // Render actual members
                chatGroupUsers.map((member) => (
                  <ListItem
                    key={member.id}
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: 2,
                      mb: 1,
                      cursor: "pointer"
                    }}
                    onClick={() => handleNavigateToProfile(member)}
                    secondaryAction={
                      member.contactStatus === "Yes" ? (
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMessageClick(member);
                          }}>
                          MESSAGE
                        </Button>
                      ) : member.contactStatus === "me" ? null : member.contactStatus ===
                        "Request Sent" ? (
                        <Button variant="text" size="small" disabled>
                          REQUEST SENT
                        </Button>
                      ) : (
                        <LoadingButton
                          loading={isConnectLoading === member.userId}
                          variant="contained"
                          size="small"
                          sx={{ boxShadow: 2 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleConnect(member);
                          }}>
                          CONNECT
                        </LoadingButton>
                      )
                    }>
                    <ListItemAvatar>
                      <Avatar src={member.pictureUrl} alt={member.appRecordName} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={`${member.firstName} ${member.lastName}${member.contactStatus === "me" ? " (me)" : ""}`}
                      secondary={member.tradeName}
                    />
                  </ListItem>
                ))}
          </List>
        </Box>
      </Modal>
      {openNewChatModal && (
        <NewChatModal
          from={"showMembers"}
          open={openNewChatModal}
          onClose={() => setOpenNewChatModal(false)}
          getChatGroupUser={getChatGroupUser}
        />
      )}
    </>
  );
}
